export default __webpack_public_path__ + "static/media/img(1).49e48cd0.png";